export default __webpack_public_path__ + "static/media/logo_symbol.2093e56b.png";